module.exports = __webpack_public_path__ + "static/img/craigThree.601ca265.png";